<template>
    <rtos :rto-categories="$store.getters['assessment/rtosByCategory']" @back="$router.back()" :action-text="$t('general.back')"></rtos>
</template>

<script>
    import Rtos from '../../components/journey/Rtos';

    export default {
        name: "UserProfile",
        components: {Rtos},
        data: () => ({

        })
    }
</script>

<style>

</style>